'use client'

import styles from './Nav.module.css'
import Link from 'next/link';
import { useState } from 'react';

import { Button } from '@indxsearch/systm';
import { Github, Book, Nuget, Key } from "@indxsearch/pixl";

export default function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header id={styles.header}>
      <Link href="/" id={styles.logo}>
        <span>Indx</span>
      </Link>

      <nav id={styles.nav}>
        <div className={styles.menuToggle}>
          <Button
            size="default"
            variant="ghost"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-expanded={menuOpen}
            aria-controls="menu"
          >
            {menuOpen ? 'Close' : 'Menu'}
          </Button>
        </div>
        <div id={styles.menu} className={menuOpen ? styles.menuOpen : ''}>

          <Button
            size="large"
            variant="ghost"
            iconLeft={<Nuget />}
            href="https://www.nuget.org/packages/IndxSearchLib/"
            className={styles.link}
          >
            Nuget
          </Button>

          <Button
            size="large"
            variant="ghost"
            iconLeft={<Book />}
            href="https://docs.indx.co"
            className={styles.link}
          >
            Docs
          </Button>

          <Button
            size="large"
            variant="ghost"
            iconLeft={<Github />}
            href="https://github.com/indxsearch"
            className={styles.link}
          >
            Github
          </Button>

          <Button
            size="large"
            variant="ghost"
            iconLeft={<Key />}
            href="https://license.indx.co"
            className={styles.link}
          >
            Get a free license
          </Button>
        </div>
      </nav>
    </header>
  )
}
